export enum SendEmailStatusEnum {
  NOT_SENT = 'NOT_SENT',
  PENDING = 'PENDING',
  SENT = 'SENT',
  READ = 'READ',
  FAILED = 'FAILED',
}
